import React from 'react';
import { useLazyQuery, useMutation, gql } from '@apollo/client';
import DestroyUnserialized from './DestroyUnserialized';

const ZONE_INVENTORY_BALANCES = gql`
  query unserializedZoneInventoryBalancesForDestroy($zoneId: ID!, $companyId: ID!) {
    unserializedPaginatedZoneInventoryBalancesByZone(
      zoneId: $zoneId
      companyId: $companyId
      includeQuarantined: true
      paginationAttributes: { limit: 200, skip: 0 }
    ) {
      zoneInventoryBalances {
        id
        stocked
        quarantined
        lot
        expiration
        zone {
          id
          name
        }
        product {
          id
          title
          fdaProduct {
            id
            name
            elevenDigitNdc
            deaSchedule
          }
          upcProduct {
            id
            upc
          }
        }
      }
      pagination {
        totalRecords
      }
    }
  }
`;

const DESTROY_UNSERIALIZED_ITEMS = gql`
  mutation destroyUnserializedItems(
    $companyId: ID!
    $destructionReason: String!
    $destroyUnserializedItemsAttributes: [DestroyUnserializedItemsAttributes!]!
  ) {
    destroyUnserializedItems(
      companyId: $companyId
      destructionReason: $destructionReason
      destroyUnserializedItemsAttributes: $destroyUnserializedItemsAttributes
    )
  }
`;

const DestroyUnserializedData = (props) => {
  const [destroyUnserializedItems] = useMutation(DESTROY_UNSERIALIZED_ITEMS);
  const [getZoneInventoryBalances, { data: zoneInventoryBalancesData }] = useLazyQuery(
    ZONE_INVENTORY_BALANCES,
    { fetchPolicy: 'network-only' }
  );

  const {
    unserializedPaginatedZoneInventoryBalancesByZone: { zoneInventoryBalances = [] } = {}
  } = zoneInventoryBalancesData || {};

  return (
    <DestroyUnserialized
      destroyUnserializedItems={destroyUnserializedItems}
      getZoneInventoryBalances={getZoneInventoryBalances}
      zoneInventoryBalances={zoneInventoryBalances}
      {...props}
    />
  );
};

export default DestroyUnserializedData;
